module.exports = __webpack_public_path__ + "img/Icon_Mail.3406029e.svg";